// import router from '@/router';
import { createGtm } from '@gtm-support/vue-gtm';
// Vue.use(VueGtm, {
//   id: process.env.VUE_APP_GTM_ID,
//   queryParams: {},
//   defer: false,
//   enabled: true,
//   debug: true,
//   loadScript: true,
//   vueRouter: router,
//   trackOnNextTick: false,
// });
export default createGtm({
    id: process.env.VUE_APP_GTM_ID,
    // queryParams: {},
    defer: false,
    enabled: true,
    debug: false,
    loadScript: true,
    // vueRouter: router,
    trackOnNextTick: false,
});
